"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var deserialize_exports = {};
__export(deserialize_exports, {
  deserializeMessage: () => deserializeMessage
});
module.exports = __toCommonJS(deserialize_exports);
function deserializeMessage(message) {
  return {
    id: message.id,
    type: message.type,
    content: message.content,
    edited: message.edited,
    creator: message.creator,
    created: message.created,
    removed: message.removed,
    extra: message.extra,
    thread: message.thread != null ? {
      threadId: message.thread.threadId,
      threadType: message.thread.threadType,
      repliesCount: message.thread.repliesCount,
      lastReply: message.thread.lastReply
    } : void 0,
    attachments: message.attachments,
    reactions: message.reactions
  };
}
__name(deserializeMessage, "deserializeMessage");
//# sourceMappingURL=deserialize.js.map
